import React, { FC } from 'react'
import styles from 'styles/components/tooltip.module.scss'

type Props = {
  direction: 'top' | 'bottom' | 'right' | 'left'
  label: string
}

const Tooltip: FC<Props> = (props) => {
  const { direction, label } = props
  const spanStyle = (() => {
    switch (direction) {
      case 'top':
        return styles.tooltip__top
      case 'bottom':
        return styles.tooltip__bottom
      case 'right':
        return styles.tooltip__right
      case 'left':
        return styles.tooltip__left
      default:
        return styles.tooltip__top
    }
  })()

  return (
    <div className={styles.tooltip}>
      <span className={spanStyle}>{label}</span>
    </div>
  )
}

export default Tooltip
